import React from 'react';
import NavigationHeader from '../homepage/components/NavigationHeader';
import HeroSection from './components/HeroSection';
import VolunteerOpportunities from './components/VolunteerOpportunities';
import CommunityStories from './components/CommunityStories';
import ProjectDashboard from './components/ProjectDashboard';
import CulturalHeritage from './components/CulturalHeritage';
import EconomicImpact from './components/EconomicImpact';
import Footer from './components/Footer';

const CommunityEngagementPlatform = () => {
  return (
    <div className="min-h-screen bg-[var(--color-background)]">
      {/* Navigation Header */}
      <NavigationHeader />
      
      {/* Add padding to account for fixed header */}
      <div className="pt-20">
        {/* Hero Section */}
        <HeroSection />
        
        {/* Volunteer Opportunities */}
        <VolunteerOpportunities />
        
        {/* Community Stories */}
        <CommunityStories />
        
        {/* Project Dashboard */}
        <ProjectDashboard />
        
        {/* Cultural Heritage */}
        <CulturalHeritage />
        
        {/* Economic Impact */}
        <EconomicImpact />
        
        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
};

export default CommunityEngagementPlatform;